import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
    listItemText: {
        paddingLeft: 20,
        '& .MuiListItemText-primary': {
            fontSize: '1.1rem !important',
            fontWeight: 'bold',
        },
    },
}))

export default useStyles
